module.exports = __webpack_public_path__ + "media/images/emoticons/paper-5d1943f3ead57bb6dbaffa64cddb3637.gif";